export function readOnlineStatus(navigatorObject = globalThis.navigator) {
  return navigatorObject?.onLine !== false;
}

export function subscribeToConnectivity(
  onChange,
  windowObject = globalThis.window,
) {
  if (!windowObject?.addEventListener || !windowObject?.removeEventListener) {
    return () => {};
  }

  const notify = () => onChange(readOnlineStatus(windowObject.navigator));
  windowObject.addEventListener("online", notify);
  windowObject.addEventListener("offline", notify);

  return () => {
    windowObject.removeEventListener("online", notify);
    windowObject.removeEventListener("offline", notify);
  };
}
